import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
const DataTokenPopoverPortal = ({
  children,
  dataTestId = 'data-token-popover-portal',
  element = 'div',
  onUnmount,
  displayPopover
}) => {
  const [container] = useState(() => {
    const el = document.createElement(element);
    el.setAttribute('data-test-id', dataTestId);
    return el;
  });
  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      onUnmount();
      if (document.body.contains(container)) {
        document.body.removeChild(container);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (displayPopover) {
      return;
    }
    onUnmount();
    if (document.body.contains(container)) {
      document.body.removeChild(container);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayPopover]);
  return /*#__PURE__*/createPortal(children, container);
};
export default DataTokenPopoverPortal;